import TableVan from './TableVan.vue';

export default {
    TableVan
}